import { avatarAnatomy } from '@chakra-ui/anatomy';
import {
  StyleFunctionProps,
  createMultiStyleConfigHelpers,
  defineStyle,
  SystemStyleObject,
} from '@chakra-ui/react';
import {
  getTypographyToken,
  runIfFn,
} from '@allergan-data-labs/alle-elements-core';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(avatarAnatomy.keys);

const getAvatarContainerStyles = defineStyle(
  ({ colorScheme: colorMode }: StyleFunctionProps): SystemStyleObject => {
    return {
      ...getTypographyToken('Body/Medium/Medium'),
      borderColor: `${colorMode}.Border/Neutral/Medium 2`,
      borderWidth: '1px',
      borderStyle: 'solid',
      backgroundColor: `${colorMode}.Container/Brand/Subtle 1`,
    };
  }
);

const getAvatarLabelStyles = defineStyle(
  ({
    color,
    colorScheme: colorMode,
  }: StyleFunctionProps): SystemStyleObject => ({
    color: color ?? `${colorMode}.Text/Brand/Bold 1`,
  })
);

const baseStyle = definePartsStyle((props) => {
  return {
    container: runIfFn(getAvatarContainerStyles, props),
    label: runIfFn(getAvatarLabelStyles, props),
  };
});

export const AvatarTheme = defineMultiStyleConfig({
  baseStyle,
  sizes: {
    xs: {
      container: {
        width: '24',
        height: '24',
      },
    },
    sm: {
      container: {
        width: '32',
        height: '32',
      },
    },
    md: {
      container: {
        width: '40',
        height: '40',
      },
      label: {
        fontSize: '16',
      },
    },
    lg: {
      container: {
        width: '56',
        height: '56',
      },
      label: {
        fontSize: '24',
      },
    },
    xl: {
      container: {
        width: '72',
        height: '72',
      },
    },
  },
});
